import { useFetchMixAPi1 } from "hooks";
import { cleanObject } from "utils";
import { getURLWithParams } from "utils/context";

export const useProdutosList = (params = {}) => {
  const newParams = cleanObject(params);
  const hasParams = Object.keys(newParams).length > 0;
  return useFetchMixAPi1(
    hasParams ? getURLWithParams("/legislacao/produtos", newParams) : null,
  );
};
